import { Mode } from '../types/graphql';
import { QueryParams } from './QueryParams';

/**
 * This utility function returns a URL prefix based on the current operating mode of the application.
 *
 * @param mode The current operating mode of the application.
 */
export function pathPrefixByMode(mode: Mode) {
  switch (mode) {
    case 'embed':
      return '/embed';
    default:
      return '';
  }
}

/**
 * This utility function returns a URL prefix based on the current operating mode of the application.
 *
 * @param mode      The current operating mode of the application.
 * @param inviteID  The inviteID related to study room
 */
export function createPathPrefix({ inviteID, mode }: { inviteID?: string | null; mode: Mode }) {
  if (inviteID && mode !== Mode.Embed) {
    return addInvitePrefix('', inviteID);
  }

  return pathPrefixByMode(mode);
}

/**
 * This utility creates an embed path based for the learn environment.
 *
 * @param teamSlug The slug of the team that owns the track.
 * @param trackSlug The slug for the track being used in the learn environment.
 * @param token Token that checks if the user has access to the embedded content.
 * @param queryParams Query parameters passed down to the learn environment.
 */
export const createEmbedPath = (teamSlug: string, trackSlug: string, token: string, queryParams?: string): string =>
  `/embed/${teamSlug}/tracks/${trackSlug}?${QueryParams.EMBED_TOKEN}=${token}${queryParams ? `&${queryParams}` : ''}`;

/**
 * This utility creates an embed url based for the learn environment.
 *
 * @param embedPath The path to the embed for the learn environment.
 */
export const createEmbedURL = (embedPath: string): string => `${window.location.origin}${embedPath}`;

/**
 * Add inviteID to permalinks when it's available
 * @param {string} permalink
 * @param {string | undefined} inviteID
 * @returns {string}
 */
export function addInvitePrefix(permalink: string, inviteID: string | undefined): string {
  if (!inviteID) {
    return permalink;
  }
  return `/study-room/invites/${inviteID}${permalink}`;
}
